import { useTranslation } from "react-i18next";
import Button from "../../ui/Button";
import AnimatedImages from "../../ui/AnimatedImageForm";
import { imageData1, imageData3, imageData5 } from "../../utils/ImageData";

function RightEquipment({
  images = [imageData1, imageData3, imageData5],
  equipmentBlock1,
  equipmentBlock2,
  equipmentText,
  button,
  onLearnMore,
}) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col h-fit-content lg:flex-row items-center lg:items-start mb-[42vw] lg:mb-0 sm:mb-64 mb-44 lg:mb-24 xl:mb-36 md:mb-64 2xl:mb-64">
      {/* Left Column: Image */}
      <div className="w-full h-fit-content lg:w-1/2 order-2 lg:order-1 mt-4 md:pt-none">
        <AnimatedImages images={images} />
      </div>

      {/* Right Column: Text */}
      <div className="w-full lg:w-1/2 xs:px-6 mb-8 lg:mb-0 flex justify-start order-1 lg:order-2">
        <div className="flex items-start w-full">
          <div className="text-left">
            {/* Title Section */}
            <div className="flex items-center mb-10 xxs:px-2">
            <div className="min-w-3 self-stretch mt-2 bg-green-800 mr-4"></div>
              <h3 className="text-4xl font-semibold text-gray-700 leading-tight">
                <span className="block">{t(equipmentBlock1)}</span>
                <span className="block">{t(equipmentBlock2)}</span>
              </h3>
            </div>

            {/* Text Section */}
            <div className="flex">
              <p className="text-gray-600 mb-10 xxs:mx-2 xs:mx-0 leading-relaxed">
                {t(equipmentText)}
              </p>
            </div>

            {/* Button Section */}
            <Button
              className=""
              bgColor="bg-green-800"
              textColor="text-white"
              boxShadowColor="#15803d"
              onClick={onLearnMore}
            >
              {t(button)}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RightEquipment;
